const timelineChips = [
  {
    filterNumber: 1,
    text: 'Denna vecka',
    isSelected: false,
  },
  {
    filterNumber: 2,
    text: 'Denna månad',
    isSelected: false,
  },
  {
    filterNumber: 3,
    text: 'Detta år',
    isSelected: false,
  },
];

const tableLabels = [
  {
    text: 'Projektnamn',
  },
  {
    text: 'Färger',
  },
  {
    text: 'Datum',
  },
  {
    text: 'Status',
  },
];

const tableInfo = [
  {
    projectName: 'Coverup skalle',
    colors: 3,
    date: '3/6 2022',
    status: 'Färdig',
  },
  {
    projectName: 'Text underarm',
    colors: 1,
    date: '4/6 2022',
    status: 'Färdig',
  },
  {
    projectName: 'Samuraj sleeve',
    colors: 4,
    date: '6/6 2022',
    status: 'Färdig',
  },
  {
    projectName: 'Ros ben',
    colors: 5,
    date: '7/6 2022',
    status: 'Färdig',
  },
  {
    projectName: 'Traditional skull',
    colors: 5,
    date: '9/6 2022',
    status: 'Färdig',
  },
  {
    projectName: 'Lejon överarm',
    colors: 3,
    date: '11/6 2022',
    status: 'Aktiv',
  },
  {
    projectName: 'Ryggtavla',
    colors: 4,
    date: '15/6 2022',
    status: 'Färdig',
  },
  {
    projectName: 'Ros ben',
    colors: 5,
    date: '7/6 2022',
    status: 'Färdig',
  },
  {
    projectName: 'Traditional skull',
    colors: 5,
    date: '9/6 2022',
    status: 'Färdig',
  },
  {
    projectName: 'Lejon överarm',
    colors: 3,
    date: '11/6 2022',
    status: 'Aktiv',
  },
  {
    projectName: 'Ryggtavla',
    colors: 4,
    date: '15/6 2022',
    status: 'Färdig',
  },
];

export const colorDeclarationTemp = {
  timelineChips,
  tableLabels,
  tableInfo,
};

export default colorDeclarationTemp;
